import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import { Grid, Stack } from '@mui/material'
import RefJobAction from 'domain/job/RefJobAction'
import JobAction from 'import/actions/JobAction'
import { getFullDate } from 'utils/DateUtil'
import { orderBy } from 'lodash'
import { nbPerPageLabelShorty } from 'referencial/constants/ReferencialConstants'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import InstallationAction from 'installation/actions/InstallationAction'
import DtoJobLogLight from 'import/dto/DtoJobLogLight'
import ErrorIcon from '@mui/icons-material/Error'
import Spinner from 'components/progress/Spinner'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { NewTable } from 'components/datatable/NewTable'

const ImportExecutionStep = ({
    jobExecutionId,
}) => {
    const dispatch = useDispatch()
    const [logs, setLogs] = useState([])
    const [job, setJob] = useState()
    const {
        installation,
    } = useSelector(store => ({
        installation: store.InstallationReducer.installation,
    }), shallowEqual)

    const automaticCallLogs = () => {
        RefJobAction.promiseJobExecutions(-500, 10).then(res => {
            JobAction.requestJobLogs(-500, jobExecutionId).then(res2 => {
                const jobLogs = res2.data.map(el => new DtoJobLogLight(el, jobExecutionId))
                const jobExecution = res.find(e => e.id === jobExecutionId)
                setJob(jobExecution)
                setLogs(jobLogs.map(l => ({
                    ...l,
                    color: l.status === 'success' ? 'green-200' : (l.status === 'error' ? 'red-200' : (l.status === 'warning' ? 'yellow-200' : null)),
                    date: getFullDate(l.date),
                })))
                if (jobExecution?.statusCode === undefined) {
                    setTimeout(() => automaticCallLogs(), 2000)
                } else if ([1, 2].includes(jobExecution?.statusCode)) {
                    dispatch(InstallationAction.fetchInstallationSTEP(installation.id))
                }
            })
        })
    }

    useEffect(() => {
        automaticCallLogs()
    }, [])

    return (
        <Grid margin={2}>
            {
                (() => {
                    switch (job?.statusCode) {
                        case 0:
                            return (
                                <Stack spacing={2} justifyContent='center' alignItems='center'>
                                    <h4>{i18n.jobFailedMessage}</h4>
                                    <h5>{i18n.jobFailedDescription}</h5>
                                    <ErrorIcon style={{ color: 'red', fontSize: 40 }} />
                                </Stack>
                            )
                        case 1:
                        case 2:
                        case 4:
                            return (
                                <Stack spacing={2} justifyContent='center' alignItems='center'>
                                    <h4>{i18n.jobSuccessMessage}</h4>
                                    <h5>{i18n.jobSuccessDescription}</h5>
                                    <CheckCircleIcon style={{ color: 'green', fontSize: 40 }} />
                                </Stack>
                            )
                        case undefined:
                            return (
                                <Stack spacing={2} justifyContent='center' alignItems='center'>
                                    <h4>{i18n.jobProgressMessage}</h4>
                                    <h5>{i18n.jobProgressDescription}</h5>
                                    <Spinner />
                                </Stack>
                            )
                        default:
                            return (
                                <Stack spacing={2} justifyContent='center' alignItems='center'>
                                    <h4>{i18n.jobUnexpectedMessage}</h4>
                                    <h5>{i18n.jobUnexpectedDescription}</h5>
                                    <ErrorIcon style={{ color: 'red', fontSize: 40 }} />
                                </Stack>
                            )
                    }
                })()
            }
            <Grid marginTop={2}>
                <NewTable
                    maxHeight='62vh'
                    headers={[{ key: 'station', value: i18n.elementLabel }, 'date', 'value', 'status']}
                    rows={orderBy(logs, 'id', 'desc')}
                    inverseDisplay
                    rowsPerPageOptions={nbPerPageLabelShorty}
                />
            </Grid>
        </Grid>
    )
}

ImportExecutionStep.propTypes = {
    jobExecutionId: PropTypes.number,
}

export default ImportExecutionStep